/* Source: /home/sidsolaiyappan/skooch_ai/shared/scheduler_form_handlers.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { getStoreSchTaskName, setStoreSchTaskName, getStoreSchTaskCat, setStoreSchTaskCat, setStoreSchTaskDur, getStoreSchTaskDurH, setStoreSchTaskDurH, getStoreSchTaskDurM, setStoreSchTaskDurM, getStoreSchTaskPri, setStoreSchTaskPri, getStoreSchTaskDL, setStoreSchTaskDL, getStoreSchTaskIsRecurring, setStoreSchTaskIsRecurring, getStoreSchTaskRecurrenceInterval, setStoreSchTaskRecurrenceInterval, getStoreSchTaskRecurrenceUnit, setStoreSchTaskRecurrenceUnit, getStoreSchTaskRecurrenceWeekday, setStoreSchTaskRecurrenceWeekday, getStoreUserId, getStoreIsAnonymous, getStoreTasks, setStoreTasks, getStoreSchedulerTasks, setStoreSchedulerTasks, setStoreSchLog, setStoreSchDirty, getStoreSchFormError, setStoreSchFormError, setStoreSchSidebarMode } from "./store.js";
import { getStoreSchEvName, setStoreSchEvName, getStoreSchEvCat, setStoreSchEvCat, getStoreSchEvLoc, setStoreSchEvLoc, getStoreSchEvStart, setStoreSchEvStart, getStoreSchEvEnd, setStoreSchEvEnd, getStoreSchEvIsRecurring, setStoreSchEvIsRecurring, getStoreSchEvIsAllDay, setStoreSchEvIsAllDay, getStoreSchEvRecurrenceInterval, setStoreSchEvRecurrenceInterval, getStoreSchEvRecurrenceUnit, setStoreSchEvRecurrenceUnit, getStoreSchEvDate, setStoreSchEvDate, getStoreSchEvMon, setStoreSchEvMon, getStoreSchEvTue, setStoreSchEvTue, getStoreSchEvWed, setStoreSchEvWed, getStoreSchEvThu, setStoreSchEvThu, getStoreSchEvFri, setStoreSchEvFri, getStoreSchEvSat, setStoreSchEvSat, getStoreSchEvSun, setStoreSchEvSun, getStoreFixedBlocks, setStoreFixedBlocks } from "./store.js";
import { getStoreSchConType, setStoreSchConType, getStoreSchConStart, setStoreSchConStart, getStoreSchConEnd, setStoreSchConEnd, getStoreSchConCat, setStoreSchConCat, getStoreSchConMax, setStoreSchConMax, getStoreSchConMon, setStoreSchConMon, getStoreSchConTue, setStoreSchConTue, getStoreSchConWed, setStoreSchConWed, getStoreSchConThu, setStoreSchConThu, getStoreSchConFri, setStoreSchConFri, getStoreSchConSat, setStoreSchConSat, getStoreSchConSun, setStoreSchConSun, getStoreSchConstraints, setStoreSchConstraints } from "./store.js";
import { setStoreDevMode, setStoreSchReportOpen, setStoreSchReasoningTarget, setStoreDevSyncScheduleAfterOptimize, setStoreSchEditTitle, setStoreSchEditPri, setStoreSchEditDL, setStoreSchEditDur, setStoreSchEditCat, setStoreSchEditLoc, getStoreSchEditStart, setStoreSchEditStart, getStoreSchEditEnd, setStoreSchEditEnd, setStoreSchEditDay, setStoreSchEditDays, setStoreSchEditDate, setStoreSchPopupDirty, setStoreSchPopupSaveState } from "./store.js";
import { getAccessToken } from "./auth_token.js";
import { createTaskRemote } from "./task_crud_remote.js";
import { schedulerRequestFailed, schedulerErrorText } from "./scheduler_request_helpers.js";
import { deleteTaskEverywhere } from "./task_lifecycle.js";
import { buildWeekdaysList, validateSchEventForm, validateSchConstraint } from "./scheduler_helpers.js";
import { minutesFromClockRange } from "./ai_message_helpers.js";
import { buildFixedEventBlocks, fixedEventId } from "./fixed_event_helpers.js";
import { createFixedEventRemote, deleteFixedEventRemote } from "./fixed_event_crud.js";
import { autoShiftEndTime } from "./scheduler_math.js";
async function addSchTask() {
  if (!getStoreSchTaskName().trim()) {
    setStoreSchFormError("Task name is required.");
    return;
  }
  if (!getStoreSchTaskCat()) {
    setStoreSchFormError("Pick a category before adding a task.");
    return;
  }
  let _durH = ((window.__skoochSchTaskDurH !== undefined) ? window.__skoochSchTaskDurH : getStoreSchTaskDurH());
  let _durM = ((window.__skoochSchTaskDurM !== undefined) ? window.__skoochSchTaskDurM : getStoreSchTaskDurM());
  let _dur = ((_durH * 60) + _durM);
  if ((_dur < 15)) {
    setStoreSchFormError("Task duration must be at least 15 minutes.");
    return;
  }
  setStoreSchTaskDur(_dur);
  if (getStoreSchTaskIsRecurring()) {
    if ((getStoreSchTaskRecurrenceInterval() < 1)) {
      setStoreSchFormError("Recurrence interval must be at least 1.");
      return;
    }
    if (!["week", "month", "year"].includes(getStoreSchTaskRecurrenceUnit())) {
      setStoreSchFormError("Recurrence unit must be week, month, or year.");
      return;
    }
    if (((getStoreSchTaskRecurrenceWeekday() < 1) || (getStoreSchTaskRecurrenceWeekday() > 7))) {
      setStoreSchFormError("Pick a weekday for the recurring task.");
      return;
    }
  }
  let newTask = null;
  let _uid = getStoreUserId();
  if (_uid) {
    let _tok = await getAccessToken();
    newTask = await createTaskRemote(_uid, getStoreIsAnonymous(), _tok, getStoreSchTaskName().trim(), getStoreSchTaskCat(), _dur, getStoreSchTaskPri(), getStoreSchTaskDL(), {"is_recurring": getStoreSchTaskIsRecurring(), "interval": getStoreSchTaskRecurrenceInterval(), "unit": getStoreSchTaskRecurrenceUnit(), "weekday": getStoreSchTaskRecurrenceWeekday()});
    if (schedulerRequestFailed(newTask)) {
      setStoreSchLog(schedulerErrorText("Couldn't save task", newTask));
      return;
    }
  } else {
    let _nid = window.__skoochNextSchId();
    newTask = {"id": ("st-" + String(_nid)), "title": getStoreSchTaskName().trim(), "category": getStoreSchTaskCat(), "duration_mins": _dur, "priority": getStoreSchTaskPri(), "deadline": getStoreSchTaskDL(), "status": "pending", "completed": false, "is_recurring": getStoreSchTaskIsRecurring(), "recurrence_interval": getStoreSchTaskRecurrenceInterval(), "recurrence_unit": getStoreSchTaskRecurrenceUnit(), "recurrence_weekday": getStoreSchTaskRecurrenceWeekday()};
  }
  setStoreTasks(getStoreTasks().concat([newTask]));
  setStoreSchedulerTasks(getStoreSchedulerTasks().concat([{"id": newTask.id, "title": newTask.title, "category": newTask.category, "duration_mins": newTask.duration_mins, "priority": newTask.priority, "deadline": newTask.deadline}]));
  setStoreSchTaskName("");
  setStoreSchTaskCat("");
  setStoreSchTaskDL("");
  setStoreSchTaskIsRecurring(false);
  setStoreSchTaskRecurrenceInterval(1);
  setStoreSchTaskRecurrenceUnit("week");
  setStoreSchTaskRecurrenceWeekday(0);
  setStoreSchFormError("");
  setStoreSchSidebarMode("parking");
  setStoreSchDirty(true);
}
async function removeSchTask(tid) {
  window.__skoochOpInFlight = true;
  let deletedOk = await deleteTaskEverywhere(tid, "Couldn't delete task");
  window.__skoochOpInFlight = false;
  if (!deletedOk) {
    return;
  }
}
async function addSchEvent() {
  let _isAllDay = getStoreSchEvIsAllDay();
  let _startTime = (_isAllDay ? "07:00" : getStoreSchEvStart());
  let _endTime = (_isAllDay ? "23:00" : getStoreSchEvEnd());
  let days = (getStoreSchEvIsRecurring() ? buildWeekdaysList(getStoreSchEvMon(), getStoreSchEvTue(), getStoreSchEvWed(), getStoreSchEvThu(), getStoreSchEvFri(), getStoreSchEvSat(), getStoreSchEvSun()) : []);
  let _v = validateSchEventForm(getStoreSchEvName(), getStoreSchEvCat(), _startTime, _endTime, getStoreSchEvIsRecurring(), getStoreSchEvRecurrenceInterval(), getStoreSchEvRecurrenceUnit(), getStoreSchEvDate(), days);
  if (!_v["ok"]) {
    setStoreSchFormError(_v["error"]);
    return;
  }
  let dur = minutesFromClockRange(_startTime, _endTime);
  let newFixedBlocks = [];
  let _uid = getStoreUserId();
  let _loc = getStoreSchEvLoc().trim();
  if (_uid) {
    let _tok = await getAccessToken();
    let _fer = await createFixedEventRemote(_uid, getStoreIsAnonymous(), _tok, getStoreSchEvName().trim(), getStoreSchEvCat(), _loc, _startTime, _endTime, dur, days, getStoreSchEvIsRecurring(), getStoreSchEvDate(), _isAllDay);
    if (!_fer["ok"]) {
      setStoreSchLog(_fer["errorMsg"]);
      return;
    }
    newFixedBlocks = _fer["blocks"];
  } else {
    let _nid = window.__skoochNextSchId();
    let now_ts = Reflect.construct(Date, []).getTime();
    let eid = ((("se-local-" + String(now_ts)) + "-") + String(_nid));
    newFixedBlocks = buildFixedEventBlocks(eid, getStoreSchEvName().trim(), getStoreSchEvCat(), _startTime, _endTime, dur, days, _isAllDay);
    newFixedBlocks = newFixedBlocks.map(b => {
      b["location"] = _loc;
      return b;
    });
    if ((!getStoreSchEvIsRecurring() && getStoreSchEvDate())) {
      newFixedBlocks = newFixedBlocks.map(b => {
        b["scheduled_date"] = getStoreSchEvDate();
        b["day"] = null;
        b["is_recurring"] = false;
        return b;
      });
    }
  }
  setStoreFixedBlocks(getStoreFixedBlocks().concat(newFixedBlocks));
  setStoreSchEvName("");
  setStoreSchEvCat("");
  setStoreSchEvLoc("");
  setStoreSchEvIsRecurring(true);
  setStoreSchEvIsAllDay(false);
  setStoreSchEvRecurrenceInterval(1);
  setStoreSchEvRecurrenceUnit("week");
  setStoreSchEvDate("");
  setStoreSchEvMon(false);
  setStoreSchEvTue(false);
  setStoreSchEvWed(false);
  setStoreSchEvThu(false);
  setStoreSchEvFri(false);
  setStoreSchEvSat(false);
  setStoreSchEvSun(false);
  setStoreSchFormError("");
  setStoreSchSidebarMode("parking");
  setStoreSchDirty(true);
}
async function removeSchEvent(eid) {
  window.__skoochOpInFlight = true;
  let _uid = getStoreUserId();
  if (_uid) {
    let _tok = await getAccessToken();
    let _dr = await deleteFixedEventRemote(_uid, getStoreIsAnonymous(), _tok, eid);
    if (!_dr["ok"]) {
      setStoreSchLog(_dr["errorMsg"]);
      window.__skoochOpInFlight = false;
      return;
    }
  }
  setStoreFixedBlocks(getStoreFixedBlocks().filter(b => {
    return (fixedEventId(b) !== eid);
  }));
  setStoreSchDirty(true);
  window.__skoochOpInFlight = false;
}
function addSchConstraint() {
  let _nid = window.__skoochNextSchId();
  let cid = ("sc-" + String(_nid));
  let days = buildWeekdaysList(getStoreSchConMon(), getStoreSchConTue(), getStoreSchConWed(), getStoreSchConThu(), getStoreSchConFri(), getStoreSchConSat(), getStoreSchConSun());
  let _v = validateSchConstraint(getStoreSchConType(), days, getStoreSchConStart(), getStoreSchConEnd(), getStoreSchConCat(), getStoreSchConMax());
  if (!_v["ok"]) {
    setStoreSchFormError(_v["error"]);
    return;
  }
  let label = _v["label"];
  setStoreSchConstraints(getStoreSchConstraints().concat([{"id": cid, "type": getStoreSchConType(), "start_time": getStoreSchConStart(), "end_time": getStoreSchConEnd(), "days": days, "category": getStoreSchConCat(), "max_hours": getStoreSchConMax(), "label": label}]));
  setStoreSchFormError("");
  setStoreSchSidebarMode("parking");
  setStoreSchConMon(false);
  setStoreSchConTue(false);
  setStoreSchConWed(false);
  setStoreSchConThu(false);
  setStoreSchConFri(false);
  setStoreSchConSat(false);
  setStoreSchConSun(false);
  setStoreSchDirty(true);
}
function onSchFormChange(field, value) {
  if (getStoreSchFormError()) {
    setStoreSchFormError("");
  }
  if ((field === "schTaskName")) {
    setStoreSchTaskName(value);
  } else if ((field === "schTaskCat")) {
    setStoreSchTaskCat(value);
  } else if ((field === "schTaskDur")) {
    setStoreSchTaskDur(value);
  } else if ((field === "schTaskDurH")) {
    setStoreSchTaskDurH(value);
    window.__skoochSchTaskDurH = value;
  } else if ((field === "schTaskDurM")) {
    setStoreSchTaskDurM(value);
    window.__skoochSchTaskDurM = value;
  } else if ((field === "schTaskPri")) {
    setStoreSchTaskPri(value);
  } else if ((field === "schTaskDL")) {
    setStoreSchTaskDL(value);
  } else if ((field === "schTaskIsRecurring")) {
    setStoreSchTaskIsRecurring(value);
  } else if ((field === "schTaskRecurrenceInterval")) {
    setStoreSchTaskRecurrenceInterval(value);
  } else if ((field === "schTaskRecurrenceUnit")) {
    setStoreSchTaskRecurrenceUnit(value);
  } else if ((field === "schTaskRecurrenceWeekday")) {
    setStoreSchTaskRecurrenceWeekday(value);
  } else if ((field === "schEvName")) {
    setStoreSchEvName(value);
  } else if ((field === "schEvCat")) {
    setStoreSchEvCat(value);
  } else if ((field === "schEvLoc")) {
    setStoreSchEvLoc(value);
  } else if ((field === "schEvStart")) {
    let _oS = getStoreSchEvStart();
    let _oE = getStoreSchEvEnd();
    setStoreSchEvStart(value);
    setStoreSchEvEnd(autoShiftEndTime(value, _oS, _oE));
  } else if ((field === "schEvEnd")) {
    setStoreSchEvEnd(value);
  } else if ((field === "schEvIsRecurring")) {
    setStoreSchEvIsRecurring(value);
  } else if ((field === "schEvIsAllDay")) {
    setStoreSchEvIsAllDay(value);
  } else if ((field === "schEvRecurrenceInterval")) {
    setStoreSchEvRecurrenceInterval(value);
  } else if ((field === "schEvRecurrenceUnit")) {
    setStoreSchEvRecurrenceUnit(value);
  } else if ((field === "schEvDate")) {
    setStoreSchEvDate(value);
  } else if ((field === "schEvMon")) {
    setStoreSchEvMon(value);
  } else if ((field === "schEvTue")) {
    setStoreSchEvTue(value);
  } else if ((field === "schEvWed")) {
    setStoreSchEvWed(value);
  } else if ((field === "schEvThu")) {
    setStoreSchEvThu(value);
  } else if ((field === "schEvFri")) {
    setStoreSchEvFri(value);
  } else if ((field === "schEvSat")) {
    setStoreSchEvSat(value);
  } else if ((field === "schEvSun")) {
    setStoreSchEvSun(value);
  } else if ((field === "schConType")) {
    setStoreSchConType(value);
  } else if ((field === "schConStart")) {
    setStoreSchConStart(value);
  } else if ((field === "schConEnd")) {
    setStoreSchConEnd(value);
  } else if ((field === "schConCat")) {
    setStoreSchConCat(value);
  } else if ((field === "schConMax")) {
    setStoreSchConMax(value);
  } else if ((field === "schConMon")) {
    setStoreSchConMon(value);
  } else if ((field === "schConTue")) {
    setStoreSchConTue(value);
  } else if ((field === "schConWed")) {
    setStoreSchConWed(value);
  } else if ((field === "schConThu")) {
    setStoreSchConThu(value);
  } else if ((field === "schConFri")) {
    setStoreSchConFri(value);
  } else if ((field === "schConSat")) {
    setStoreSchConSat(value);
  } else if ((field === "schConSun")) {
    setStoreSchConSun(value);
  }
}
function onSchStateChange(field, value) {
  if ((field === "devMode")) {
    setStoreDevMode(value);
  } else if ((field === "schReportOpen")) {
    setStoreSchReportOpen(value);
  } else if ((field === "schReasoningTarget")) {
    setStoreSchReasoningTarget(value);
  } else if ((field === "devSyncScheduleAfterOptimize")) {
    setStoreDevSyncScheduleAfterOptimize(value);
  } else if ((field === "schSidebarMode")) {
    setStoreSchSidebarMode(value);
  } else if ((field === "schFormError")) {
    setStoreSchFormError(value);
  } else if ((field === "schEditTitle")) {
    setStoreSchEditTitle(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditPri")) {
    setStoreSchEditPri(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditDL")) {
    setStoreSchEditDL(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditDur")) {
    setStoreSchEditDur(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditCat")) {
    setStoreSchEditCat(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditLoc")) {
    setStoreSchEditLoc(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditStart")) {
    let _oES = getStoreSchEditStart();
    let _oEE = getStoreSchEditEnd();
    setStoreSchEditStart(value);
    setStoreSchEditEnd(autoShiftEndTime(value, _oES, _oEE));
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditEnd")) {
    setStoreSchEditEnd(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditDay")) {
    setStoreSchEditDay(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditDays")) {
    setStoreSchEditDays(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  } else if ((field === "schEditDate")) {
    setStoreSchEditDate(value);
    setStoreSchPopupDirty(true);
    setStoreSchPopupSaveState("idle");
  }
}
export {addSchConstraint, addSchEvent, addSchTask, onSchFormChange, onSchStateChange, removeSchEvent, removeSchTask};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:addSchTask": {"is_writer": false, "touches": ["*"]}, "func:removeSchTask": {"is_writer": true, "touches": ["*"]}, "func:addSchEvent": {"is_writer": false, "touches": ["*"]}, "func:removeSchEvent": {"is_writer": true, "touches": ["*"]}, "func:addSchConstraint": {"is_writer": false, "touches": ["*"]}, "func:onSchFormChange": {"is_writer": true, "touches": ["*"]}, "func:onSchStateChange": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=scheduler_form_handlers.js.map
